/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Read_OnlyInputs */

const id_reseller_pricing_read_only = /** @type {(inputs: Reseller_Pricing_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun Anda belum dapat mengubah harga domain saat ini.`)
};

const en_reseller_pricing_read_only = /** @type {(inputs: Reseller_Pricing_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account cannot change domain pricing right now.`)
};

/**
* | output |
* | --- |
* | "Your account cannot change domain pricing right now." |
*
* @param {Reseller_Pricing_Read_OnlyInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_read_only = /** @type {((inputs?: Reseller_Pricing_Read_OnlyInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Read_OnlyInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_read_only(inputs)
	return id_reseller_pricing_read_only(inputs)
});